import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import modais from './modules/modais'
import pedidos from './modules/pedidos'
import anuncios from './modules/anuncios'
import meusAnuncios from './modules/meusAnuncios'
import componentes from './modules/componentes'
import arquivos from './modules/arquivos'
import pacotes from './modules/pacotes'
import forum from './modules/forum'
import globais from './modules/globais'
import usuario from './modules/usuario'

Vue.use(Vuex)

const modules = {
  auth,
  modais,
  anuncios,
  meusAnuncios,
  componentes,
  pedidos,
  arquivos,
  pacotes,
  forum,
  globais,
  usuario,
}

export default new Vuex.Store({
  modules
})
